import { createAsyncThunk } from '@reduxjs/toolkit';
import vendorService from '../../../api/services/vendor';
import weddingService from '../../../api/services/wedding';
import subscriptionService from '../../../api/services/subscription';

export const postVendorInfo = createAsyncThunk('vendor/postVendorInfo', async requestData => {
  let formData = new FormData();

  if (Array.isArray(requestData.images)) {
    requestData.images.forEach((image, index) => {
      formData.append(`images`, image);
    });
  }

  if (requestData.banner !== null) {
    formData.append('banner', requestData.banner);
  }

  formData.append('name', requestData.name);

  formData.append('address', requestData.address);

  formData.append('showAddress', requestData.showAddress);

  formData.append('phoneNumber', requestData.phoneNumber);

  formData.append('emailToShow', requestData.emailToShow);

  formData.append('vendorCategoryId', requestData.vendorCategoryId);

  if (requestData.instagram !== '') {
    formData.append('instagram', requestData.instagram);
  }
  if (requestData.facebook !== '') {
    formData.append('facebook', requestData.facebook);
  }
  if (requestData.twitter !== '') {
    formData.append('twitter', requestData.twitter);
  }
  if (requestData.tiktok !== '') {
    formData.append('tiktok', requestData.tiktok);
  }

  if (requestData.googlePlaceId && requestData.googlePlaceId !== '') {
    formData.append('googlePlaceId', requestData.googlePlaceId);
  }

  if (requestData.websiteLink !== '') {
    formData.append('websiteLink', requestData.websiteLink);
  }

  if (requestData.links.length > 0) {
    for (const link of requestData.links) {
      if (link !== '') {
        formData.append('links[]', link);
      }
    }
  }

  return await vendorService.postVendorInfo(formData);
});

export const editVendorInfo = createAsyncThunk('vendor/editVendorInfo', async requestData => {
  let formData = new FormData();

  if (Array.isArray(requestData.images)) {
    requestData.images.forEach((image, index) => {
      formData.append(`images`, image);
    });
  }

  if (requestData.banner !== null) {
    formData.append('banner', requestData.banner.file);
  }

  formData.append('name', requestData.name);

  formData.append('address', requestData.address);

  formData.append('showAddress', requestData.showAddress);

  formData.append('phoneNumber', requestData.phoneNumber);

  formData.append('emailToShow', requestData.emailToShow);

  if (requestData.instagram) {
    formData.append('instagram', requestData.instagram);
  }
  if (requestData.facebook) {
    formData.append('facebook', requestData.facebook);
  }
  if (requestData.twitter) {
    formData.append('twitter', requestData.twitter);
  }
  if (requestData.tiktok) {
    formData.append('tiktok', requestData.tiktok);
  }
  if (requestData.websiteLink) {
    formData.append('websiteLink', requestData.websiteLink);
  }

  if (requestData.links.length > 0) {
    for (const link of requestData.links) {
      if (link) {
        formData.append('links[]', JSON.stringify(link));
      }
    }
  }

  if (requestData.newLinks.length > 0) {
    for (const link of requestData.newLinks) {
      if (link !== '') {
        formData.append('newLinks[]', link);
      }
    }
  }

  if (requestData.photos.length > 0) {
    for (const photo of requestData.photos) {
      if (photo) {
        formData.append('photos[]', JSON.stringify(photo));
      }
    }
  }

  if (requestData.googlePlaceId !== '') {
    formData.append('googlePlaceId', requestData.googlePlaceId);
  }

  return await vendorService.editVendorInfo(formData);
});

export const fetchAllVendorCategories = createAsyncThunk('vendor/fetchAllVendorCategories', async () => {
  return await vendorService.fetchAllVendorCategories();
});

export const getClientsForVendor = createAsyncThunk('vendor/getClientsForVendor', async ({ page, search }) => {
  if (!page) {
    page = 1;
  }
  return await vendorService.getClientsForVendor(page, search);
});

export const fetchVendorInfo = createAsyncThunk('vendor/fetchVendorInfo', async () => {
  return await vendorService.fetchVendorInfo();
});

export const getClientById = createAsyncThunk('vendor/getClientById', async requestData => {
  return await vendorService.getClientById(requestData);
});

export const setNoteForClient = createAsyncThunk('vendor/setNoteForClient', async requestData => {
  return await vendorService.setNoteForClient(requestData);
});

export const changeStatusForClient = createAsyncThunk('vendor/changeStatusForClient', async requestData => {
  return await vendorService.changeStatusForClient(requestData);
});

export const setWorkingHoursForVendor = createAsyncThunk('vendor/setWorkingHoursForVendor', async requestData => {
  return await vendorService.setWorkingHours(requestData);
});

export const getVendorWorkingHours = createAsyncThunk('vendor/getVendorWorkingHours', async () => {
  return await vendorService.getWorkingHours();
});

export const getAllClients = createAsyncThunk('vendor/getAllClients', async () => {
  return await vendorService.getAllClients();
});

export const acceptClientRequest = createAsyncThunk('vendor/acceptClientRequest', async ({ id, notificationId }) => {
  return await vendorService.acceptClientRequest(id, notificationId);
});

export const createClientByVendor = createAsyncThunk('vendor/createClientByVendor', async requestData => {
  return await weddingService.createClientByVendor(requestData);
});

export const createHashtagsForClient = createAsyncThunk(
  'vendor/createHashtagsForClient',
  async ({ id, newHashtags, hashtags }) => {
    return await weddingService.createHashtagsForClient(id, newHashtags, hashtags);
  },
);

export const rejectClientRequest = createAsyncThunk('vendor/rejectClientRequest', async ({ id, notificationId }) => {
  return await vendorService.rejectClientRequest(id, notificationId);
});

export const subscribeAndAddPaymentMethod = createAsyncThunk(
  'vendor/subscribeAndAddPaymentMethod',
  async ({ paymentMethodId }) => {
    return await subscriptionService.subscribeAndAddPaymentMethod(paymentMethodId);
  },
);

export const addPaymentMethod = createAsyncThunk('vendor/addPaymentMethod', async ({ paymentMethodId }) => {
  return await subscriptionService.addPaymentMethod(paymentMethodId);
});

export const getPaymentIntentsForVendor = createAsyncThunk('vendor/getPaymentIntentsForVendor', async ({ page }) => {
  if (!page) {
    page = 1;
  }
  return await vendorService.getPaymentIntentsForVendor(page);
});

export const cancelSubscription = createAsyncThunk('vendor/cancelSubscription', async () => {
  return await subscriptionService.cancelSubscription();
});

export const subscribeWithCoupon = createAsyncThunk('vendor/subscribeWithCoupon', async body => {
  return await subscriptionService.subscribeWithCoupon(body);
});
